import { jwtDecode } from "jwt-decode";

export function validateToken(token) {
  try {
    const decoded = jwtDecode(token);

    const currentTime = Math.floor(Date.now() / 1000);

    return {
        decoded : decoded,
        isValid : decoded.exp > currentTime //cek apakah sudah melebihi masa berlaku
    }
  } catch (error) {
    console.error("Token tidak valid atau rusak", error);
    return {
        decoded : null,
        isValid : false
    }
  }
}
